import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_4 = { class: "testimonials-carousel__item-text" }
const _hoisted_5 = { class: "testimonials-pagination" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!

  return (_ctx.testimonials.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ 'content-block': !_ctx.previewModeOnly })
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.previewModeOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Testimonials"))
            : _createCommentVNode("", true),
          (!_ctx.previewModeOnly)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "What people say about us"))
            : _createCommentVNode("", true),
          _createVNode(_component_v_carousel, {
            modelValue: _ctx.currentSlide,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentSlide) = $event)),
            cycle: "",
            "hide-delimiters": "",
            "show-arrows": "hover",
            class: "testimonials-carousel",
            height: "auto"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonialComputed, (response, i) => {
                return (_openBlock(), _createBlock(_component_v_carousel_item, {
                  key: i,
                  class: "testimonials-carousel__item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(response.testimonial), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonialComputed, (response, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass(["testimonials-pagination__item", { active: _ctx.currentSlide === i }]),
                onClick: ($event: any) => (_ctx.currentSlide = i)
              }, [
                _createElementVNode("img", {
                  src: response.image,
                  alt: ""
                }, null, 8, _hoisted_7),
                (_ctx.currentSlide === i)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(response.name), 1))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_6))
            }), 128))
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}